import {
  authenticationContext,
  commonActions,
  sessionManagement,
  uiActions,
  cmxTypeguards
} from '@codametrix/ui-common';
import { Auth, UserContext } from '../../actions/action-types';
import { MiddlewareProcessor, middleWareWrapper } from './middleware-utils';
import { syncSessionHeartbeatScheduler } from '../sync-session-heartbeat-scheduler';
import { stopSessionHeartbeatScheduler } from '@codametrix/client-session';

const { UserInterface } = commonActions;
const { activityMonitor } = sessionManagement;

export let isSSOUser = false;

const authTokenProcessor: MiddlewareProcessor = (api, next, action) => {
  if (!cmxTypeguards.isReduxAction(action)) {
    return next(action);
  }
  // Do stuff
  if (action.type === Auth.TOKEN_AVAILABLE) {
    // store the authorization
    const { payload } = action;
    authenticationContext.setToken(payload.token);
    if (payload.token) {
      window.sessionStorage.setItem('authToken', `${payload.token}`);
    }
    if (payload.expiryTimeToLive) {
      activityMonitor.expiryTimeout = payload.expiryTimeToLive;
    }
    // Service Desk / provider-directory cache bearer tokens and only re-read on
    // DID_REFRESH. BEGIN_REFRESH + tokenAvailable used to leave them on the
    // pre-renewal JWT until it expired (ERR / 500 after ~10 min).
    activityMonitor.shouldRefresh(payload);
    syncSessionHeartbeatScheduler(api.dispatch);
    import('../../store/store').then(m => m.tokenRequestListener.startListening());
  } else if (action.type === UserContext.CHOOSE_CONTEXT) {
    const { payload } = action;
    // capture expiry ttls in both TOKEN_AVAILABLE and CHOOSE_CONTEXT
    // it is not available in ALL cases due to the user set-up.
    // some users with a single context don't have the ttl.
    if (payload.expiryTimeToLive) {
      activityMonitor.expiryTimeout = payload.expiryTimeToLive;
    }
    authenticationContext.setContextId(payload.activeContextId);
    syncSessionHeartbeatScheduler(api.dispatch);
  } else if (action.type === Auth.TOGGLE_SSO_USER) {
    const { payload } = action;
    isSSOUser = payload;
  } else if (action.type === UserInterface.LOGOUT) {
    activityMonitor.stop();
    stopSessionHeartbeatScheduler();
    import('../../store/store').then(m => m.tokenRequestListener.stopListening());
    next(uiActions.resetCommonState());
  }

  return next(action);
};
const AuthTokenMiddleware = middleWareWrapper(authTokenProcessor);

export default AuthTokenMiddleware;
